import { module } from 'angular';
import qrCodeGeneratorComponent from './qr-code-generator.component';
import './qr-code-generator.scss';

export default module('app')
	.component('qrCodeGenerator', qrCodeGeneratorComponent)
	.name;
